import react, { useEffect, useState, useRef, useLayoutEffect } from "react";
import axios from "axios";
import "../App.css";
import Navigation from "./Navigation";
import { Link } from "react-router-dom";
import Navbar from "./navbar";
import Facebook from "./Facebook";
import Google from "./Google";
import Alert from "./alert/alert";
import Dashboard from "./dashboard/dashboard";
import { URL_LOGIN } from "../api/constants";
import Cookies from "js-cookie";
import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";

gsap.registerPlugin(CSSPlugin);
var timeline;

function StudentForm(props) {
  const boxRef = useRef(null);
  const containerRef = useRef(null);
  const formRef = useRef(null);

  //hooks useState
  const [isLoggedIn, setisLoggedIn] = useState(false);
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [erroruser, seterroruser] = useState("");
  const [errorPass, seterrorpass] = useState("");

  const [alert, setalert] = useState(false);

  // login form validations
  const [alertmsg, setalertmsg] = useState("");

  //Submit Form
  const handlechange = async (e) => {
    e.preventDefault();

    if (username == "") {
      setalert(true);
      setalertmsg("username can not be blank !");
    } else if (password == "") {
      setalert(true);
      setalertmsg("password can not be blank !");
    } else if (password !== "") {
      setalert(false);
      setalertmsg("");
    }
    console.log(username, password);
    var data = JSON.stringify({
      user: {
        userName: username,
        password: password,
        userType: "ADMIN",
      },
    });

    var config = {
      method: "post",
      url: URL_LOGIN,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        console.log(response);
        var checkuser = response.data.message;
        console.log(checkuser);
        var userDetails = JSON.parse(checkuser);
        console.log(userDetails);
        console.log(userDetails.username);
        console.log(userDetails.MCODE);
        console.log(userDetails.userType);

        Cookies.set("userType", userDetails.userType);

        if (userDetails.userType === "TICKETMASTER") {
          localStorage.setItem("login", "true");
          var inFifteenMinutes = new Date(
            new Date().getTime() + 3 * 60 * 60 * 1000
          ); // after 3 hours from login

          Cookies.set("orgmcode", userDetails.MCODE, {
            expires: inFifteenMinutes,
            secure: true,
            sameSite: "strict",
            path: "/",
          });

          window.location.href = "/BuyTicket";
        } else if (userDetails.userType === "EVENTMASTER") {
          localStorage.setItem("login", "true");
          Cookies.set("orgmcode", userDetails.MCODE);

          window.location.href = "/dashboard";
        } else if (userDetails.userType === "REPORTING") {
          localStorage.setItem("login", "true");
          Cookies.set("orgmcode", userDetails.MCODE);
          window.location.href = "/dashboard/reports";
        } else if (userDetails.userType === "VISITOR") {
          setalert(true);
          setalertmsg("No User Found !");
          setTimeout(() => {
            window.location.href = "/";
          }, 4000);
        } else {
          var success = response.data.isSuccess;
          //var inFifteenMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);
          var inFifteenMinutes = new Date(
            new Date().getTime() + 3 * 60 * 60 * 1000
          ); // after 3 hours from login
          Cookies.set("orgmcode", userDetails.MCODE, {
            expires: inFifteenMinutes,
            secure: true,
            sameSite: "strict",
            path: "/",
          });
          Cookies.set("orgName", userDetails.username, {
            expires: inFifteenMinutes,
            secure: true,
            sameSite: "strict",
            path: "/",
          });
          if (success == true) {
            setalert(true);
            setalertmsg("login success");
            setisLoggedIn(true);
            timeline.timeScale(3).reverse();
            setTimeout(() => {
              window.location.href = "/dashboard";
              localStorage.setItem("login", "true");
            }, 1000);
          } else {
            setalert(true);
            setalertmsg("Username or password is incorrect");
            setisLoggedIn(false);

            setTimeout(() => {
              setalert(false);
            }, 2000);
          }
        }
      })
      .catch(function (error) {
        console.log(" login faliure" + error);
      });
  };

  useLayoutEffect(() => {
    const container = containerRef.current;
    const elements = container.querySelectorAll(".myForm  div");

    gsap.set(elements, { opacity: 0 });

    timeline = gsap.timeline();
    elements.forEach((element, index) => {
      timeline.to(element, { opacity: 1, duration: 0.5 }, index * 0.5);
      timeline.to(".myForm", { scale: 1, duration: 0.5 }, index * 0.1);
    });
  }, []);

  return (
    <>
      {alert ? <Alert msg={alertmsg} /> : ""}
      <div className="myForm">
        <div className="box" ref={boxRef}>
          <div className="container" ref={containerRef}>
            <div className="form" ref={formRef}>
              <form action="">
                <img
                  className="center"
                  src="data:image/png;base64,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"
                ></img>
                <center>
                  <h3 className="heading">Admin Portal</h3>
                </center>
                <div className="inputBox">
                  <input
                    type="text"
                    placeholder="username"
                    value={username}
                    onChange={(e) => setusername(e.target.value)}
                  />
                  <div className="error">{erroruser}</div>
                </div>

                <div className="inputBox">
                  <input
                    type="password"
                    placeholder="password"
                    value={password}
                    onChange={(e) => setpassword(e.target.value)}
                  />
                  <div className="error">{errorPass}</div>
                </div>

                <div className="inputBox">
                  <input type="submit" value="Submit" onClick={handlechange} />
                </div>
                <br />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentForm;
